import { formatISO, isValid } from 'date-fns';

export const mapToIso = (date: Date | null | undefined): Date | null => {
	return isValid(date) && date ? (formatISO(date) as any) : null;
};
